import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'

const HotelsList = ({ hotels, selectedHotel, onSelect }) => {
    const handleToggle = (hotelName) => {
        if (typeof onSelect === 'function') {
            if (selectedHotel === hotelName) {
                onSelect('')
            } else {
                onSelect(hotelName)
            }
        }
    }

    return (
        <ul className="trip-select-list">
            {hotels.map((hotel) => {
                const isSelected = selectedHotel === hotel

                return (
                    <li key={hotel} className="trip-select-list__item">
                        <label className="trip-select-list__label">
                            <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => handleToggle(hotel)}
                                className="trip-select-list__input"
                            />
                            <span></span>
                            {hotel}
                        </label>
                    </li>
                )
            })}
        </ul>
    )
}

HotelsList.propTypes = {
    hotels: PropTypes.arrayOf(PropTypes.string).isRequired,
    selectedHotel: PropTypes.string,
    onSelect: PropTypes.func.isRequired
}

export default HotelsList


